export const ConstructFetchBody = (method: string, parameters: Array<any>) => {
	return {
		body: (new URLSearchParams({
			'id': '200',
			'method': method,
			'params': btoa(JSON.stringify((parameters)))
		})).toString(),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		method: 'POST'
	};
};

export const FormatDate = (date: Date) => {
	return date.toLocaleDateString('en-US', {
		weekday: 'short',
		month: 'numeric',
		day: 'numeric',
		year: '2-digit'
	});
};

export const FormatNumber = (number: number) => {
    return number.toLocaleString();
};

export const FormatTime = (date: Date) => {
	return date.toLocaleTimeString('en-US', {
		hour: 'numeric',
		minute: '2-digit',
		hour12: true
	}).replace(' ', '').toLocaleLowerCase();
};

export const MoveArrayItem = (array: Array<any>, fromIndex: number, toIndex: number) => {
    const item = array[fromIndex];

    array.splice(fromIndex, 1);
    array.splice(toIndex, 0, item);

    return array;
}

export const UrlQueryParam = (param: string) => {
    return (new URL(window.location.href)).searchParams.get(param);
};